// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1TIao","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__tPrl5"};